"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartItemPromo_1 = require("./CartItemPromo");
exports.default = CartItemPromo_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/CartItemPromo/index.js
// module id = 174
// module chunks = 8